<template>
  <router-view />
</template>

<script>
export default {
  name: 'TemplateConsoleLayout'
}
</script>

<style scoped>
</style>
